import gql from 'graphql-tag'

const stockAdvicesGetQuery = gql`
  query stockAdvicesGet($offset: Int, $limit: Int, $criteria: Object, $sorting: Object) {
    stockAdvicesGet(
      input: { limit: $limit, offset: $offset, criteria: $criteria, sort: $sorting, select: $select, nested: true }
    ) @rest(type: "StockAdvicesResult", method: "POST", path: "stock-advice/list") {
      results
      paging
    }
  }
`

export default stockAdvicesGetQuery
